import React from "react";
import PropTypes from "prop-types";

import UserPopup from "../ui/UserPopup";

const UserProfile = (props) => {
  const { name, userId, firstName, lastName, email } = props;

  return <UserPopup userInfo={{ name, userId, firstName, lastName, email }} />;
};

UserProfile.propTypes = {
  name: PropTypes.string.isRequired,
  userId: PropTypes.string,
};

export default UserProfile;
